import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            waitingAreas: [],
        }
    },

    computed: {
        ...mapGetters(['selectedContainer']),
    },

    methods: {
        async fetchWaitingAreas(container = null) {
            container = container || this.selectedContainer

            let { data } = await this.$http.get(
                `WaitingArea/${container.ContainerID}`
            )
            data.sort((a, b) => {
                if (a && b && a.Description && b.Description) {
                    return a.Description.localeCompare(b.Description, 'en', {
                        numeric: true,
                    })
                }
            })
            this.waitingAreas = data
            return data
        },
    },
}
